import React from 'react';
import { Mountain, Plane, Mic, Users, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

const TYPES = [
  { value: 'road_trip', label: 'Road Trip', icon: Mountain, hint: 'Pit stops, route, road squad' },
  { value: 'vacation', label: 'Vacation', icon: Plane, hint: 'Itinerary, stays, places' },
  { value: 'conference', label: 'Conference', icon: Mic, hint: 'Sessions, speakers, Q&A' },
  { value: 'social', label: 'Social', icon: Users, hint: 'Gatherings, parties, meetups' },
  { value: 'custom', label: 'Custom', icon: Sparkles, hint: 'Anything you can dream of' },
];

export const EventTypePicker = ({ value, onChange }) => {
  return (
    <div data-testid="event-type-picker" className="grid grid-cols-1 gap-3">
      {TYPES.map((t) => {
        const Icon = t.icon;
        const active = value === t.value;
        return (
          <motion.button
            key={t.value}
            type="button"
            data-testid={`event-type-${t.value}`}
            onClick={() => onChange(t.value)}
            whileTap={{ scale: 0.985 }}
            className={`relative text-left p-4 rounded-2xl border transition-colors flex items-center gap-4 ${
              active ? 'border-primary bg-primary/5' : 'border-border bg-card hover:bg-secondary'
            }`}
          >
            <div className={`h-12 w-12 rounded-xl flex items-center justify-center ${active ? 'gradient-fab text-white' : 'bg-secondary text-foreground'}`}>
              <Icon className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <div className="font-semibold text-base">{t.label}</div>
              <div className="text-xs text-muted-foreground mt-0.5">{t.hint}</div>
            </div>
            <div className={`h-5 w-5 rounded-full border ${active ? 'border-primary bg-primary' : 'border-border'} flex items-center justify-center`}>
              {active && <span className="h-2 w-2 rounded-full bg-white" />}
            </div>
          </motion.button>
        );
      })}
    </div>
  );
};

export const EVENT_TYPES = TYPES;
